import React from "react";
import styled from "styled-components";
import { devices } from "../../styles";

export default function Modal({
	isOpen,
	children = "Test content",
	leaveApp = false,
	customPadding = false,
}) {
	return isOpen ? (
		<Wrapper>
			 <PopupWrapperInner>
				<Container leaveApp={leaveApp} customPadding={customPadding}>
					
					<Content leaveApp={leaveApp} customPadding={customPadding}>{children}</Content>
				</Container>
			</PopupWrapperInner>
		</Wrapper>
	) : null;
}

const Wrapper = styled.div`
    
    position: fixed;
    width: 100%;
    height: 100vh;
    top: 0;
    left: 0;
    z-index: 10;
    background: rgba(0, 0, 0, 0.75);
`;
const PopupWrapperInner = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    margin: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;

    @media ${devices.tablet} {
        align-items: center;
    }
`;

const Container = styled.div`
	display: flex;
	padding: 24px 16px;
	flex-direction: column;
	align-items: center;
	gap: 24px;
	align-self: stretch;
	margin-inline: 24px;
    width: 327px;
    min-width: 90vw;
    background-color: #fff;
    padding-top: 24px;
    border-radius: 24px;
    margin: auto;
	max-width:90vw;

    @media ${devices.mobile} {
        width:481px;
		min-width:auto
    }
	@media ${devices.tablet} {
        width:481px;
		padding: ${(props) => (props.leaveApp || props.customPadding) ? '24px' : '24px 72px'};
    }
`;

const Content = styled.div`
	margin: auto;
	max-width: 100%;
	text-align: center;
	position: relative;	
	padding: ${(props) => (props.leaveApp || props.customPadding) ? '0' : '28px 24px'};
	color: #000;

	img {
		height: 48px;
		width: auto;
		margin-bottom: 24px;
	}

	h3 {
		margin-bottom: 24px;
	}

	p {
		margin-bottom: 40px;
	}

	button{
	margin-bottom: 8px;
	}
	button + button {
  		margin-left: 8px;
		@media ${devices.mobile} {
			margin-left: 24px;
		}
	}
`